import { forwardRef } from "react"

// MUI
import { useTheme } from "@mui/material"
import MuiIconButton from "@mui/material/IconButton"

// ----------------------------------------------|| ICON BUTTON - COMPONENTS || ----------------------------------------------

// eslint-disable-next-line react/display-name
const IconButton = forwardRef(({ children, sx, ...others }, ref) => {
  const theme = useTheme()
  return (
    <MuiIconButton
      ref={ref}
      disableRipple
      {...others}
      sx={{
        ...sx,
        fontSize: 18,
        fontWeight: 700,
        p: 1.1,
        color: theme.palette.text.primary,
        borderRadius: "4px",
        backgroundColor: theme.palette.background.paper,
        "&:hover": {
          backgroundColor: theme.palette.grey[400]
        }
      }}
    >
      {children}
    </MuiIconButton>
  )
})

export default IconButton
